import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import { useForm, useWatch } from "react-hook-form"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { API_URL } from '../common/constants';
import classNames from "classnames";
import { StyledMember, StyledPanel } from "../stylesheets/styles";
import { useNavigate, useLocation } from 'react-router-dom';
import BgComponent from '../components/BgComponent';

const Register = () => {
  const { 
      register, 
      handleSubmit, 
      watch,
      setValue,
      setError, 
      formState: { errors, isSubmitting }
    } = useForm({
    defaultValues: {
      Name: '',
      Password: '',
      PhoneNumber: '',
      Email: '',
      Gender: ''
    }
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState(location.state?.formData || {});

  const watchValue = watch();
  
  useEffect(() => {
    // 如果有傳遞過來的 formData，則設置表單的初始值
    if (formData) {
      setValue('Name', formData.Name || '');
      setValue('Password', formData.Password || '');
      setValue('ConfirmPassword', formData.ConfirmPassword || '');
      setValue('PhoneNumber', formData.PhoneNumber || '');
      setValue('Email', formData.Email || '');
      setValue('Gender', formData.Gender || '');
    }
  }, [formData, setValue]);
  
  const onSubmit = async (data) => {
    setFormData(data); // 保存表單數據
    try {
      const response = await axios.post(`${API_URL}/api/member/register`, data, {
        headers: { 'Content-Type': 'application/json' }
      });

      const { isSuccess, message, result } = response.data;
      setError("root", {
        message: message,
        isSuccess: isSuccess,
      });

      if (isSuccess) {
        navigate('/verification', { state: { formData: data, result: result, message: message } });
      }
    } catch (error) {
      setError("root", {
        message: error.message,
      });
    }
  };

  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">註冊新會員</h1>
                  <p className="text-center">電子信箱與手機門號至少需填寫一組</p>
                </div>
                <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group mb-3">
                    <label htmlFor="Email" className="form-label">電子信箱</label>
                    <input 
                      {...register("Email", { 
                        required: {
                          value: watchValue.PhoneNumber === '' ? true : false,
                          message: '請至少輸入手機或email！'
                        },
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                          message: '請輸入正確的電子信箱格式'
                        },
                        value: {
                          value: watch('PhoneNumber') || '',
                          message: '請至少輸入手機或email！'
                        }
                      })} 
                      type="email"
                      id="Email" 
                      className={`form-control ${errors.Email ? "is-invalid" : ""}`}
                      placeholder="請輸入電子信箱" 
                    />
                    {errors.Email && <p className="form-helper text-danger">{errors.Email.message}</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="PhoneNumber" className="form-label">手機門號</label>
                    <input 
                      {...register('PhoneNumber', { 
                        required: {
                          value: watchValue.Email === '' ? true : false,
                          message: '請至少輸入手機或email！'
                        },
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: '請輸入正確的手機門號格式'
                        },
                        value: {
                          value: watch('Email') || '',
                            validate: (value) => {
                            if (watchValue.Email === '' && value === '') {
                              return '請至少輸入手機或email！';
                            }
                            return true;
                            },
                          message: '請至少輸入手機或email！'
                        }
                      })} 
                      id="PhoneNumber" 
                      className={`form-control ${errors.PhoneNumber ? "is-invalid" : ""}`}
                      placeholder="請輸入手機門號:0900000000"
                    />
                    {errors.PhoneNumber && <p className="form-helper text-danger">{errors.PhoneNumber.message}</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="password" className="form-label">密碼*</label>
                    <input 
                      {...register('Password', { 
                        required: true, 
                        minLength: {
                          value: 8,
                          message: '密碼至少8個字元'
                        }
                      })} 
                      type="password"
                      id="Password" 
                      className={`form-control ${errors.Password ? "is-invalid" : ""}`}
                      placeholder="請輸入註冊密碼"
                    />
                    {errors.Password && <p className="form-helper text-danger">{errors.Password.message}</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="ConfirmPassword" className="form-label">再次輸入密碼*</label>
                    <input 
                      {...register("ConfirmPassword", {
                        required: "確認密碼為必填欄位",
                        validate: (value) =>
                          value === watchValue.Password || "密碼不一致",
                      })}
                      type="password"
                      id="ConfirmPassword" 
                      className={`form-control ${errors.ConfirmPassword ? "is-invalid" : ""}`}
                      placeholder="再次確認密碼"
                    />
                    {errors.ConfirmPassword && (
                      <p className="form-helper text-danger">{errors.ConfirmPassword.message}</p>
                    )}
                  </div>   
                  <div className="form-group mb-3">
                    <label htmlFor="Name" className="form-label">姓名*</label>
                    <input 
                      {...register('Name', { required: true})} 
                      type="text"
                      id="Name" 
                      className={`form-control ${errors.Name ? "is-invalid" : ""}`}
                      placeholder="請輸入姓名"
                    />
                    {errors.Name && <p className="form-helper text-danger">請輸入姓名</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="gender" className="form-label">性別*</label>
                    <select 
                      {...register("Gender", { required: true })}
                      className="form-select"
                      id="gender"
                    >
                      <option value="M">男</option>
                      <option value="F">女</option>
                    </select>
                  </div>
                  <div className="form-button pt-4">
                    <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                      { isSubmitting ? '處理中...' : '下一步，驗證信箱或手機' }
                    </Button>
                    {errors.root && <p className={classNames("form-helper text-center mt-2", errors.root.isSuccess ? 'text-success' : 'text-danger')}>{errors.root.message}</p>}
                    <div className="text-center mt-3">
                      <Link to="/login" className="btn btn-link">已經有帳號？登入</Link>
                    </div>
                  </div>
                </Form>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};


export default Register;